export const ActionBarTags = {
    ActionBar: 'atlantis-action-bar',
    ActionBarDivider: 'atlantis-action-bar-divider'
};